import { Button, notification } from 'antd';
import { fetcher } from '../../../utils/fetcher';

export const CrownAiScoreExplanations = () => {
  const [api, contextHolder] = notification.useNotification();

  const handleClick = async () => {
    await fetcher('/admin/crown_ai_score_explanations');
    api.info({
      message: 'スコア解説を更新しました',
      duration: 0,
    });
  };

  return (
    <div>
      {contextHolder}
      <Button onClick={handleClick}>スコア解説を更新</Button>
    </div>
  );
};
